export const USER_CRM_SUCCESS = "USER_ME";
export const USER_CRM_REQUEST = "USER_CRM_REQUEST";
export const USER_CRM_ERROR = "USER_ME";
export const USER_SHOW_TOS_DIALOG = "USER_SHOW_TOS_DIALOG";
export const USER_HIDE_TOS_DIALOG = "USER_HIDE_TOS_DIALOG";
export const USER_SHOW_TOS_DIALOG_PARTNER = "USER_SHOW_TOS_DIALOG_PARTNER";
export const USER_HIDE_TOS_DIALOG_PARTNER = "USER_HIDE_TOS_DIALOG_PARTNER";
export const USER_SHOW_TAC_DIALOG = "USER_SHOW_TAC_DIALOG";
export const USER_HIDE_TAC_DIALOG = "USER_HIDE_TAC_DIALOG";
export const USER_ACCEPTED_TOS = "USER_ACCEPTED_TOS";
export const USER_SHOW_PENDING_INVITE_DIALOG =
  "USER_SHOW_PENDING_INVITE_DIALOG";
export const USER_HIDE_PENDING_INVITE_DIALOG =
  "USER_HIDE_PENDING_INVITE_DIALOG";
export const USER_CHECK_TAC_TOS_DIALOG = "USER_CHECK_TAC_DIALOG";
export const USER_CHECK_PENDING_INVITE_DIALOG =
  "USER_CHECK_PENDING_INVITE_DIALOG";
export const USER_KNOWLEDGEBASE_REQUEST = "USER_KNOWLEDGEBASE_REQUEST";
export const USER_KNOWLEDGEBASE_SUCCESS = "USER_KNOWLEDGEBASE_SUCCESS";
export const USER_KNOWLEDGEBASE_ERROR = "USER_KNOWLEDGEBASE_ERROR";
export const USER_SET_ROUTE = "USER_SET_ROUTE";
export const USER_GET_NEXT_DIALOG = "USER_GET_NEXT_DIALOG";
export const USER_SET_GLOBAL_NOTIFICATIONS = "USER_SET_GLOBAL_NOTIFICATIONS";
export const USER_CRM_LICENCE_STATUS_REQUEST =
  "USER_CRM_LICENCE_STATUS_REQUEST";
export const USER_CRM_LICENCE_STATUS_SUCCESS =
  "USER_CRM_LICENCE_STATUS_SUCCESS";
export const USER_CRM_LICENCE_STATUS_ERROR = "USER_CRM_LICENCE_STATUS_ERROR";
export const USER_CRM_LICENCE_STATUS_REQUIRED =
  "USER_CRM_LICENCE_STATUS_REQUIRED";
export const USER_CRM_RELOAD = "USER_CRM_RELOAD";
